const LEADING_QUOTE_REGEX = /^"([^"]+)"/;

/**
 * Extracts a leading quoted string from an evidence summary.
 *
 * Summaries for DocumentReferences may contain a quote in the format:
 *   "Patient has diabetes" - Consult Note (retrieved 1/15/2026)
 *
 * Returns the text inside the quotes, or undefined if no leading quote is present.
 */
export function extractQuoteFromSummary(summary: string | undefined): string | undefined {
  if (!summary) {
    return undefined;
  }
  const match = summary.match(LEADING_QUOTE_REGEX);
  return match?.[1];
}
